// @ts-strict-ignore
import { Pipe, PipeTransform } from '@angular/core';
import {LMProcessIndicatorService} from '@field/processindicator/lm-process-indicator.service';

@Pipe({
  name: 'lmProcessIndicatorTooltip',
  standalone: false
})

export class LMProcessIndicatorTooltipPipe implements PipeTransform {
  constructor(private lmProcessIndicatorService: LMProcessIndicatorService) {}

  transform(data: LMProcessIndicatorDisplayData): string {
    if (data === undefined) {
      return null;
    }

    return `
      <div class="lm-process-indicator-tooltip details">
      <span class="label">${data.label}</span>
      ${data.status ? `<span class="heading">${data.displayStatus}</span>` : ``}
      ${data.stepApproversDisplay?.map((a) => `
            <div class="item">
            ${a.icon ? `<svg class="icon icon-${a.displayIcon} ${this.lmProcessIndicatorService.getApproverIconColorClass(a.icon, true)}" focusable="false" aria-hidden="true" role="presentation">
              <use href="#icon-${a.displayIcon}"></use>
            </svg>` : ``}
            <span>${a.approver}</span>
            ${a.tag ? `<span class="${this.lmProcessIndicatorService.getTagClasses(a)}">${a.displayTag.value}</span>` : ``}
          </div>`).join('')}
    `;
  }
}
